export default __webpack_public_path__ + "images/0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4.png";